import { render, staticRenderFns } from "./DisasterForm.vue?vue&type=template&id=39599a12&"
import script from "./DisasterForm.vue?vue&type=script&lang=js&"
export * from "./DisasterForm.vue?vue&type=script&lang=js&"
import style0 from "./DisasterForm.vue?vue&type=style&index=0&id=39599a12&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports